import { useMemo } from 'react';
import { imageBasePath } from 'constants';
import useRoleplayHelper from 'features/realplays/RealPlay.helper';
import classes from './ReviewQualifiedRealPlay.module.scss';
import { InputSelect } from 'shared_ui_components';
import { CustomButton } from 'shared_ui_components';
import useReviewScenarioMutation from 'features/realplays/services/mutations/useReviewScenario';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import RealPlayQualifiedDataHelper from 'features/realplays/RealPlayQualifiedData.helper';
import { withoutScenarios } from 'features/roleplay/RoleplayConstants';
import RealPlayQualifiedLogic from './RealPlayQualified.logic';

const RealPlayHeaderQualified = ({ isLoading }) => {
  const {
    navigate,
    PATHS,
    reset,
    title,
    formattedDate,
    onSelectedValue,
    scenariosLength,
    value,
    options,
    isEditing,
    selectedScenario,
    scenarios,
    final_decision,
    confirmAll,
    handlePass,
    handleFail,
    isDisabled,
    navigateNext,
  } = RealPlayQualifiedLogic();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.4rem',
        width: '100%',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 500 }}>
        <div className={classes.header}>
          <button
            onClick={() => {
              navigate(PATHS.ROLEPLAYS);
              reset();
            }}
          >
            <img src={imageBasePath + 'back_arrow.svg'} alt="Return" />
          </button>
          <span className="heading4">
            Interactive Roleplay "{isLoading ? '...' : title}" {formattedDate()}
          </span>
        </div>
        {scenariosLength > 1 && (
          <div className={classes.scenarioSelector}>
            <InputSelect
              value={value}
              onChange={(opt) => onSelectedValue(opt?.value || '')}
              options={options}
              closeMenuOnSelect
              disabled={isLoading || isEditing}
            />
          </div>
        )}
        {!withoutScenarios.includes(selectedScenario?.name) &&
          scenarios?.length === 1 &&
          selectedScenario?.name !== title && (
            <span className="heading5">Scenario: {selectedScenario?.name}</span>
          )}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: final_decision ? 'space-between' : 'flex-end',
          fontWeight: 500,
        }}
      >
        {final_decision && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <span
              style={{
                backgroundColor: final_decision === 'FAIL' ? '#FEF9C3' : '#DCFCE7',
                padding: '0 0.5rem',
                borderRadius: '3px',
                height: '22px',
                display: 'grid',
                placeItems: 'center',
                width: 'fit-content',
              }}
            >
              <p
                style={{
                  color: final_decision === 'FAIL' ? '#FACC15' : '#22C55E',
                  fontWeight: '600',
                  fontSize: '0.75rem',
                  lineHeight: '10px',
                  height: '10px',
                  textWrap: 'nowrap',
                }}
              >
                {final_decision === 'FAIL' ? 'Not approved' : 'Passed successfully'}
              </p>
            </span>
            <p style={{ color: '#272d37', fontSize: '12px', fontWeight: 400, lineHeight: '18px' }}>
              {final_decision === 'FAIL'
                ? 'Your video does not comply with the established rating criteria.'
                : 'Your video complies with the established rating criteria'}
            </p>
          </div>
        )}
        {confirmAll ? (
          <CustomButton
            onClick={() => navigateNext()}
            className="primaryBtn"
            style={{ width: '20%' }}
          >
            Confirm result
          </CustomButton>
        ) : (
          <CustomButton
            onClick={final_decision === 'FAIL' ? () => handleFail() : () => handlePass()}
            className="primaryBtn"
            style={{ width: '20%' }}
            disabled={isDisabled}
          >
            Confirm result
          </CustomButton>
        )}
      </div>
    </div>
  );
};

export default RealPlayHeaderQualified;
